import { createSelector } from "@ngrx/store";
import { AppState } from "../reducers";

const settingsFeature = (state: AppState) => state.settings;

export const isChangingPassword = createSelector(settingsFeature, (state) => ({
  isChangingPassword: state.isChangingPassword,
}));

export const isResettingPassword = createSelector(settingsFeature, (state) => ({
  isResettingPassword: state.isResettingPassword,
}));

export const isChangingLanguage = createSelector(settingsFeature, (state) => ({
  isChangingLanguage: state.isChangingLanguage,
}));
